<template>
  <AppShell
    v-model:current-lang="currentLang"
    variante="produto"
    evitar-banner-mobile
    @lang-change="onLangChange"
  >
    <!-- ALERTA TOPO: Aviso de mudança de nome -->
    <template #alerta>
      <AlertaTopo :destaque="t.alertaForte">{{ t.alertaTexto }}</AlertaTopo>
    </template>

    <!-- HERO -->
    <PageHero
      :logo-src="logoBranco"
      logo-alt="OligoCheck"
      :badge="t.heroBadge"
      badge-variante="azul"
      :subtitulo="t.heroSubtitulo"
    >
      <template #titulo>
        <span class="ds-texto-gradiente">OligoCheck</span><span class="titulo-virgula">,</span>
        <span class="titulo-antigo">
          {{ t.heroAntigoTexto }} <span class="titulo-riscado">OligoScan</span>
        </span>
      </template>

      <template #ctas>
        <p class="caminhos-pergunta">{{ t.caminhosPergunta }}</p>

        <div class="caminhos-grid">
            <!-- CAMINHO A: COMPRAR -->
            <a href="#formulario-compra" @click.prevent="scrollToForm" class="caminho-card caminho-compra">
              <div class="caminho-icone">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="9" cy="21" r="1"/>
                  <circle cx="20" cy="21" r="1"/>
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
                </svg>
              </div>
              <div class="caminho-conteudo">
                <span class="caminho-label">{{ t.caminhoCompraLabel }}</span>
                <strong class="caminho-titulo">{{ t.caminhoCompraTitulo }}</strong>
                <span class="caminho-desc">{{ t.caminhoCompraDesc }}</span>
              </div>
              <div class="caminho-seta">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
              </div>
            </a>

            <!-- CAMINHO B: SUPORTE -->
            <a :href="whatsappSuporteUrl" target="_blank" rel="noopener" class="caminho-card caminho-suporte">
              <div class="caminho-icone suporte-icone">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
              </div>
              <div class="caminho-conteudo">
                <span class="caminho-label">{{ t.caminhoSuporteLabel }}</span>
                <strong class="caminho-titulo">{{ t.caminhoSuporteTitulo }}</strong>
                <span class="caminho-desc">{{ t.caminhoSuporteDesc }}</span>
              </div>
              <div class="caminho-seta">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
              </div>
            </a>
          </div>
      </template>

      <template #trust>
        <TrustBar :items="[
          { texto: t.trust1, icone: 'shield' },
          { texto: t.trust2, icone: 'clock' },
          { texto: t.trust3, icone: 'users' }
        ]" />
      </template>
    </PageHero>

    <!-- SEÇÃO EXPLICATIVA: Por que a mudança? -->
    <SecaoPadrao variante="alt">
      <div class="explicativa-grid">
        <div class="explicativa-texto">
          <BadgePill>{{ t.explicaBadge }}</BadgePill>
          <h2 class="ds-secao-titulo">
            {{ t.explicaTitulo1 }}
            <span class="ds-texto-gradiente">{{ t.explicaTituloDestaque }}</span>
            {{ t.explicaTitulo2 }}
          </h2>
          <p class="explicativa-desc">
            {{ t.explicaDesc }}
          </p>

          <div class="antes-depois">
            <div class="ad-item ad-antes">
              <span class="ad-label">{{ t.antes }}</span>
              <strong>OligoScan</strong>
            </div>
            <div class="ad-seta">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
            </div>
            <div class="ad-item ad-depois">
              <span class="ad-label">{{ t.agora }}</span>
              <strong class="ds-texto-gradiente">OligoCheck</strong>
            </div>
          </div>

          <ul class="explicativa-lista">
            <li v-for="txt in [t.lista1, t.lista2, t.lista3, t.lista4]" :key="txt">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              <span>{{ txt }}</span>
            </li>
          </ul>
        </div>

        <div class="explicativa-visual">
          <div class="visual-glow"></div>
          <img src="@/assets/images/hero-device.png" alt="OligoCheck" class="visual-img" />
        </div>
      </div>
    </SecaoPadrao>

    <!-- SEÇÃO: O QUE É -->
    <SecaoPadrao>
      <SecaoHeader
        :badge="t.oqueBadge"
        :titulo-antes="t.oqueTitulo1"
        titulo-destaque="OligoCheck?"
        :subtitulo="t.oqueSub"
      />

      <div class="features-grid">
        <FeatureCard :titulo="t.feat1Titulo" :descricao="t.feat1Desc">
          <template #icone>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
          </template>
        </FeatureCard>

        <FeatureCard :titulo="t.feat2Titulo" :descricao="t.feat2Desc">
          <template #icone>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"/><line x1="16" y1="8" x2="2" y2="22"/><line x1="17.5" y1="15" x2="9" y2="15"/></svg>
          </template>
        </FeatureCard>

        <FeatureCard :titulo="t.feat3Titulo" :descricao="t.feat3Desc">
          <template #icone>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
          </template>
        </FeatureCard>

        <FeatureCard :titulo="t.feat4Titulo" :descricao="t.feat4Desc">
          <template #icone>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
          </template>
        </FeatureCard>
      </div>

        <!-- BLOCO TÉCNICO: ESPECTROFOTOMETRIA -->
        <div class="tech-box">
          <div class="tech-box-grid">
            <div class="tech-box-icone">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 12h4l3-9 4 18 3-9h4"/>
              </svg>
            </div>
            <div class="tech-box-conteudo">
              <div class="tech-box-label">{{ t.techLabel }}</div>
              <h3 class="tech-box-titulo">{{ t.techTitulo }}</h3>
              <p class="tech-box-desc">{{ t.techDesc }}</p>
              <ul class="tech-box-lista">
                <li>
                  <div class="tech-step-body">
                    <strong>{{ t.techPasso1Titulo }}</strong>
                    <span>{{ t.techPasso1Desc }}</span>
                  </div>
                </li>
                <li>
                  <div class="tech-step-body">
                    <strong>{{ t.techPasso2Titulo }}</strong>
                    <span>{{ t.techPasso2Desc }}</span>
                  </div>
                </li>
                <li>
                  <div class="tech-step-body">
                    <strong>{{ t.techPasso3Titulo }}</strong>
                    <span>{{ t.techPasso3Desc }}</span>
                  </div>
                </li>
              </ul>
              <p class="tech-box-nota">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
                {{ t.techNota }}
              </p>
            </div>
          </div>
        </div>
    </SecaoPadrao>

    <!-- FAQ -->
    <SecaoPadrao variante="alt">
      <SecaoHeader :badge="t.faqBadge">
        <template #titulo>{{ t.faqTitulo }}</template>
      </SecaoHeader>

      <Faq :items="t.faqItems" />
    </SecaoPadrao>

    <!-- FORMULÁRIO DE CAPTURA -->
    <SecaoPadrao id="formulario-compra" class="secao-formulario">
      <FormularioLead
        :idioma="currentLang"
        :active-campaign="acConfig"
        :redirect-to="{ name: 'oligoscan-gracias' }"
      />
    </SecaoPadrao>

    <!-- FOOTER -->
    <template #rodape>
      <RodapeSite
        marca="OligoCheck"
        :texto="t.rodapeTexto"
        :direitos="t.rodapeDireitos"
      />
    </template>
  </AppShell>
</template>

<script setup>
import { ref, computed } from 'vue'
import FormularioLead from '@/components/global/formulario/FormularioLead.vue'
import AppShell from '@/components/global/layout/AppShell.vue'
import AlertaTopo from '@/components/global/layout/AlertaTopo.vue'
import PageHero from '@/components/global/layout/PageHero.vue'
import RodapeSite from '@/components/global/layout/RodapeSite.vue'
import SecaoPadrao from '@/components/global/secao/SecaoPadrao.vue'
import SecaoHeader from '@/components/global/secao/SecaoHeader.vue'
import BadgePill from '@/components/global/secao/BadgePill.vue'
import FeatureCard from '@/components/global/ui/FeatureCard.vue'
import TrustBar from '@/components/global/ui/TrustBar.vue'
import Faq from '@/components/global/ui/Faq.vue'
import logoBranco from '@/assets/images/logo-branco.svg'
import { useSeo } from '@/composables/useSeo'

const currentLang = ref('es')

const onLangChange = () => {
  /* AppShell marca como escolha manual internamente. */
}

// Configuração do ActiveCampaign (formulário 39) repassada ao componente
// global de formulário. Para outra seção/campanha, basta trocar os IDs.
const acConfig = {
  endpoint: 'https://eduardgasset95711.activehosted.com/proc.php',
  u: '39',
  f: '39',
  s: '',
  c: '0',
  m: '0',
  act: 'sub',
  v: '2',
  or: 'b64d7958-6041-44e9-9ee9-f268efd44426'
}

const whatsappSuporte = '34609644237'
const whatsappSuporteUrl = computed(() => {
  const msgs = {
    es: 'Hola, tengo un equipo OligoScan / OligoCheck y necesito soporte.',
    pt: 'Olá, tenho um equipamento OligoScan / OligoCheck e preciso de suporte.',
    en: 'Hello, I have an OligoScan / OligoCheck device and need support.'
  }
  const msg = encodeURIComponent(msgs[currentLang.value])
  return `https://api.whatsapp.com/send/?phone=${whatsappSuporte}&text=${msg}`
})

const scrollToForm = () => {
  const el = document.getElementById('formulario-compra')
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

const translations = {
  es: {
    alertaForte: 'AVISO IMPORTANTE:',
    alertaTexto: 'OligoScan ha sido actualizado y ahora se llama OligoCheck.',
    heroBadge: 'OligoScan ahora es OligoCheck',
    heroAntigoTexto: 'antes',
    heroSubtitulo: 'La misma tecnología líder mundial en análisis mineral intracelular, ahora más accesible, más precisa y más cercana a ti.',
    caminhosPergunta: '¿Qué necesitas hoy?',
    caminhoCompraLabel: 'QUIERO ADQUIRIRLO',
    caminhoCompraTitulo: 'Hablar con un consultor',
    caminhoCompraDesc: 'Propuesta personalizada según tu perfil profesional y objetivos.',
    caminhoSuporteLabel: 'YA TENGO EL EQUIPO',
    caminhoSuporteTitulo: 'Necesito ayuda',
    caminhoSuporteDesc: 'Atención directa por WhatsApp para usuarios OligoCheck / OligoScan.',
    trust1: 'Registrado y homologado',
    trust2: '+10 años en el mercado',
    trust3: '+12.000 profesionales',

    explicaBadge: '¿Por qué el cambio?',
    explicaTitulo1: 'La evolución del OligoScan,',
    explicaTituloDestaque: 'más precisa',
    explicaTitulo2: 'y al alcance de todos',
    explicaDesc: 'OligoCheck es la evolución del OligoScan: la tecnología en la que miles de profesionales ya confían, ahora más accesible y más precisa. Misma base técnica reconocida — análisis mineral intracelular no invasivo, de alta precisión y en tiempo real — con una experiencia de uso, soporte y resultados renovados.',
    antes: 'Antes',
    agora: 'Ahora',
    lista1: 'Misma tecnología de espectrofotometría, ahora más precisa',
    lista2: 'Misma tecnología de confianza de miles de profesionales',
    lista3: 'Interpretación automática de los resultados',
    lista4: 'Soporte técnico y formación continua incluidos',

    oqueBadge: 'Conoce la tecnología',
    oqueTitulo1: '¿Qué es el',
    oqueSub: 'Un sistema profesional que mide más de 40 oligoelementos, metales pesados y estrés oxidativo directamente desde la palma de la mano del paciente, en menos de 5 segundos.',
    feat1Titulo: 'Resultados en segundos',
    feat1Desc: 'Análisis completo en menos de 5 segundos, sin esperas ni laboratorio.',
    feat2Titulo: 'No invasivo, sin dolor',
    feat2Desc: 'Sin agujas, sin sangre. Sólo se apoya la mano en el sensor.',
    feat3Titulo: 'Medición intracelular',
    feat3Desc: 'Mide el nivel real en los tejidos, no sólo lo que circula en sangre.',
    feat4Titulo: 'Informe profesional',
    feat4Desc: 'Laudo completo listo para entregar al paciente en la propia consulta.',

    techLabel: 'La tecnología por detrás',
    techTitulo: 'Espectrofotometría de absorción adaptada a tejidos vivos',
    techDesc: 'OligoCheck utiliza una variante patentada de la espectrofotometría de absorción óptica, una técnica de referencia en laboratorios clínicos para cuantificar minerales. El equipo mide directamente en el tejido vivo de la palma de la mano, de forma totalmente no invasiva y con precisión de grado laboratorial.',
    techPasso1Titulo: 'Emisión multiespectro',
    techPasso1Desc: 'Un módulo óptico emite haces de luz en longitudes de onda específicas (desde el UV cercano hasta el infrarrojo) calibradas individualmente para cada oligoelemento y metal analizado.',
    techPasso2Titulo: 'Análisis del patrón de absorción',
    techPasso2Desc: 'Cada mineral absorbe la luz en una longitud de onda única. Sensores de alta sensibilidad miden la luz reflejada por las capas superficiales de la piel y calculan la concentración intracelular correspondiente.',
    techPasso3Titulo: 'Cálculo algorítmico',
    techPasso3Desc: 'Un algoritmo propietario cruza los datos espectrales con una base comparativa de más de 2 millones de mediciones clínicas, generando valores cuantitativos de más de 40 parámetros en menos de 5 segundos.',
    techNota: 'Método registrado, no invasivo, sin radiación ionizante y aprobado para uso profesional.',

    faqBadge: 'Preguntas frecuentes',
    faqTitulo: 'Lo que más nos preguntan',
    faqItems: [
      { question: '¿OligoScan y OligoCheck son lo mismo?', answer: 'Es la misma tecnología en la que miles de profesionales ya confían, ahora con una identidad actualizada. OligoCheck es la evolución del OligoScan: mantiene el mismo nivel técnico y la misma precisión reconocida, ahora más accesible.' },
      { question: 'Tengo un OligoScan antiguo. ¿Sigue funcionando? ¿Hay soporte?', answer: 'Sí, seguimos dando soporte a los equipos OligoScan de generaciones anteriores. Si necesitas ayuda técnica, recambios u orientación, haz clic en el botón de Soporte Post-venta y hablaremos contigo por WhatsApp.' },
      { question: '¿Cuál es la diferencia respecto al equipo antiguo?', answer: 'OligoCheck mantiene la misma base tecnológica (espectrofotometría no invasiva), pero incorpora mayor precisión, resultados más rápidos, interpretación automática y un servicio de soporte y formación completamente renovado.' },
      { question: '¿Cómo puedo comprar el OligoCheck?', answer: 'Rellena el formulario al final de esta página. Un consultor se pondrá en contacto contigo por WhatsApp para entender tu caso y enviarte una propuesta personalizada con las condiciones vigentes.' },
      { question: '¿Ofrecéis formación y soporte continuo?', answer: 'Sí. Todos los clientes reciben formación completa para operar el equipo, interpretar los resultados y aplicarlos en consulta. Además, ofrecemos soporte técnico continuo por WhatsApp y email.' }
    ],

    rodapeTexto: 'La evolución del OligoScan. Análisis mineral intracelular en tiempo real.',
    rodapeDireitos: 'Todos los derechos reservados.'
  },

  pt: {
    alertaForte: 'AVISO IMPORTANTE:',
    alertaTexto: 'O OligoScan foi atualizado e agora se chama OligoCheck.',
    heroBadge: 'OligoScan agora é OligoCheck',
    heroAntigoTexto: 'antigo',
    heroSubtitulo: 'A mesma tecnologia líder mundial em análise mineral intracelular, agora mais acessível, mais precisa e mais próxima de você.',
    caminhosPergunta: 'Do que você precisa hoje?',
    caminhoCompraLabel: 'QUERO ADQUIRIR',
    caminhoCompraTitulo: 'Falar com um consultor',
    caminhoCompraDesc: 'Proposta personalizada conforme seu perfil profissional e objetivos.',
    caminhoSuporteLabel: 'JÁ TENHO O EQUIPAMENTO',
    caminhoSuporteTitulo: 'Preciso de ajuda',
    caminhoSuporteDesc: 'Atendimento direto pelo WhatsApp para usuários OligoCheck / OligoScan.',
    trust1: 'Registrado e homologado',
    trust2: '+10 anos no mercado',
    trust3: '+12.000 profissionais',

    explicaBadge: 'Por que a mudança?',
    explicaTitulo1: 'A evolução do OligoScan,',
    explicaTituloDestaque: 'mais precisa',
    explicaTitulo2: 'e ao seu alcance',
    explicaDesc: 'O OligoCheck é a evolução do OligoScan: a tecnologia em que milhares de profissionais já confiam, agora mais acessível e mais precisa. A mesma base técnica reconhecida — análise mineral intracelular não invasiva, de alta precisão e em tempo real — com uma experiência de uso, suporte e resultados renovados.',
    antes: 'Antes',
    agora: 'Agora',
    lista1: 'Mesma tecnologia de espectrofotometria, agora mais precisa',
    lista2: 'Mesma tecnologia de confiança de milhares de profissionais',
    lista3: 'Interpretação automática dos resultados',
    lista4: 'Suporte técnico e treinamento contínuo inclusos',

    oqueBadge: 'Conheça a tecnologia',
    oqueTitulo1: 'O que é o',
    oqueSub: 'Um sistema profissional que mede mais de 40 oligoelementos, metais pesados e estresse oxidativo diretamente na palma da mão do paciente, em menos de 5 segundos.',
    feat1Titulo: 'Resultados em segundos',
    feat1Desc: 'Análise completa em menos de 5 segundos, sem esperas nem laboratório.',
    feat2Titulo: 'Não invasivo, indolor',
    feat2Desc: 'Sem agulhas, sem sangue. Basta apoiar a mão no sensor.',
    feat3Titulo: 'Medição intracelular',
    feat3Desc: 'Mede o nível real nos tecidos, não apenas o que circula no sangue.',
    feat4Titulo: 'Laudo profissional',
    feat4Desc: 'Relatório completo pronto para entregar ao paciente na própria consulta.',

    techLabel: 'A tecnologia por trás',
    techTitulo: 'Espectrofotometria de absorção adaptada a tecidos vivos',
    techDesc: 'O OligoCheck utiliza uma variante patenteada da espectrofotometria de absorção óptica, uma técnica de referência em laboratórios clínicos para quantificar minerais. O aparelho mede diretamente no tecido vivo da palma da mão, de forma totalmente não invasiva e com precisão de nível laboratorial.',
    techPasso1Titulo: 'Emissão multiespectro',
    techPasso1Desc: 'Um módulo óptico emite feixes de luz em comprimentos de onda específicos (do UV próximo ao infravermelho) calibrados individualmente para cada oligoelemento e metal analisado.',
    techPasso2Titulo: 'Análise do padrão de absorção',
    techPasso2Desc: 'Cada mineral absorve a luz em um comprimento de onda único. Sensores de alta sensibilidade medem a luz refletida pelas camadas superficiais da pele e calculam a concentração intracelular correspondente.',
    techPasso3Titulo: 'Cálculo algorítmico',
    techPasso3Desc: 'Um algoritmo proprietário cruza os dados espectrais com uma base comparativa de mais de 2 milhões de medições clínicas, gerando valores quantitativos de mais de 40 parâmetros em menos de 5 segundos.',
    techNota: 'Método registrado, não invasivo, sem radiação ionizante e aprovado para uso profissional.',

    faqBadge: 'Perguntas frequentes',
    faqTitulo: 'O que mais nos perguntam',
    faqItems: [
      { question: 'OligoScan e OligoCheck são a mesma coisa?', answer: 'É a mesma tecnologia em que milhares de profissionais já confiam, agora com uma identidade atualizada. OligoCheck é a evolução do OligoScan: mantém o mesmo nível técnico e a mesma precisão reconhecida, agora mais acessível.' },
      { question: 'Tenho um OligoScan antigo. Ainda funciona? Há suporte?', answer: 'Sim, continuamos dando suporte aos aparelhos OligoScan de gerações anteriores. Se precisar de ajuda técnica, peças ou orientação, clique no botão de Suporte Pós-venda e falaremos com você pelo WhatsApp.' },
      { question: 'Qual a diferença em relação ao aparelho antigo?', answer: 'O OligoCheck mantém a mesma base tecnológica (espectrofotometria não invasiva), mas incorpora maior precisão, resultados mais rápidos, interpretação automática dos resultados e um suporte e treinamento completamente renovados.' },
      { question: 'Como posso comprar o OligoCheck?', answer: 'Preencha o formulário ao final desta página. Um consultor entrará em contato pelo WhatsApp para entender seu caso e enviar uma proposta personalizada com as condições vigentes.' },
      { question: 'Oferecem treinamento e suporte contínuo?', answer: 'Sim. Todos os clientes recebem treinamento completo para operar o aparelho, interpretar os resultados e aplicá-los na consulta. Além disso, oferecemos suporte técnico contínuo por WhatsApp e e-mail.' }
    ],

    rodapeTexto: 'A evolução do OligoScan. Análise mineral intracelular em tempo real.',
    rodapeDireitos: 'Todos os direitos reservados.'
  },

  en: {
    alertaForte: 'IMPORTANT NOTICE:',
    alertaTexto: 'OligoScan has been updated and is now called OligoCheck.',
    heroBadge: 'OligoScan is now OligoCheck',
    heroAntigoTexto: 'formerly',
    heroSubtitulo: 'The same world-leading technology in intracellular mineral analysis, now more accessible, more accurate and closer to you.',
    caminhosPergunta: 'What do you need today?',
    caminhoCompraLabel: 'I WANT TO BUY',
    caminhoCompraTitulo: 'Talk to a consultant',
    caminhoCompraDesc: 'Personalized proposal based on your professional profile and goals.',
    caminhoSuporteLabel: 'I ALREADY OWN THE DEVICE',
    caminhoSuporteTitulo: 'I need help',
    caminhoSuporteDesc: 'Direct WhatsApp support for OligoCheck / OligoScan users.',
    trust1: 'Registered and certified',
    trust2: '+10 years in the market',
    trust3: '+12,000 professionals',

    explicaBadge: 'Why the change?',
    explicaTitulo1: 'The evolution of OligoScan,',
    explicaTituloDestaque: 'more accurate',
    explicaTitulo2: 'and within reach',
    explicaDesc: 'OligoCheck is the evolution of OligoScan: the technology thousands of professionals already trust, now more accessible and more accurate. Same recognized technical foundation — non-invasive, high-precision, real-time intracellular mineral analysis — with a renewed experience, support and results.',
    antes: 'Before',
    agora: 'Now',
    lista1: 'Same spectrophotometry technology, now more accurate',
    lista2: 'Same technology trusted by thousands of professionals',
    lista3: 'Automatic results interpretation',
    lista4: 'Technical support and ongoing training included',

    oqueBadge: 'Know the technology',
    oqueTitulo1: 'What is',
    oqueSub: 'A professional system that measures over 40 trace elements, heavy metals, and oxidative stress directly from the palm of the patient\'s hand, in less than 5 seconds.',
    feat1Titulo: 'Results in seconds',
    feat1Desc: 'Complete analysis in under 5 seconds — no waiting, no lab.',
    feat2Titulo: 'Non-invasive, painless',
    feat2Desc: 'No needles, no blood draw. Just rest the hand on the sensor.',
    feat3Titulo: 'Intracellular measurement',
    feat3Desc: 'Measures the real level in tissues, not only what circulates in blood.',
    feat4Titulo: 'Professional report',
    feat4Desc: 'Full report ready to share with the patient in the same consultation.',

    techLabel: 'The technology behind',
    techTitulo: 'Absorption spectrophotometry adapted to living tissue',
    techDesc: 'OligoCheck uses a patented variant of optical absorption spectrophotometry, a reference technique in clinical laboratories for quantifying minerals. The device measures directly in the living tissue of the palm of the hand, completely non-invasively and with laboratory-grade precision.',
    techPasso1Titulo: 'Multi-spectrum emission',
    techPasso1Desc: 'An optical module emits light beams at specific wavelengths (from near UV to infrared) individually calibrated for each trace element and metal analyzed.',
    techPasso2Titulo: 'Absorption pattern analysis',
    techPasso2Desc: 'Every mineral absorbs light at a unique wavelength. High-sensitivity sensors measure the light reflected by the surface layers of the skin and calculate the corresponding intracellular concentration.',
    techPasso3Titulo: 'Algorithmic calculation',
    techPasso3Desc: 'A proprietary algorithm cross-references the spectral data against a comparative database of over 2 million clinical measurements, generating quantitative values for 40+ parameters in under 5 seconds.',
    techNota: 'Registered method, non-invasive, no ionizing radiation, approved for professional use.',

    faqBadge: 'Frequently asked questions',
    faqTitulo: 'What we get asked the most',
    faqItems: [
      { question: 'Are OligoScan and OligoCheck the same?', answer: 'It is the same technology thousands of professionals already trust, now with an updated identity. OligoCheck is the evolution of OligoScan: it keeps the same technical standard and the same recognized precision, now more accessible.' },
      { question: 'I have an old OligoScan. Does it still work? Is there support?', answer: 'Yes, we still support older OligoScan generations. If you need technical help, spare parts, or guidance, click the Post-sale Support button and we will talk to you on WhatsApp.' },
      { question: 'What is different from the old device?', answer: 'OligoCheck keeps the same technological foundation (non-invasive spectrophotometry) but adds higher precision, faster results, automatic interpretation of results and a completely renewed support and training program.' },
      { question: 'How can I buy the OligoCheck?', answer: 'Fill out the form at the bottom of this page. A consultant will contact you via WhatsApp to understand your needs and send you a tailored proposal with current conditions.' },
      { question: 'Do you offer training and ongoing support?', answer: 'Yes. Every client receives full training on operating the device, interpreting results, and applying them in practice. We also provide ongoing technical support via WhatsApp and email.' }
    ],

    rodapeTexto: 'The evolution of OligoScan. Intracellular mineral analysis in real time.',
    rodapeDireitos: 'All rights reserved.'
  }
}

const t = computed(() => translations[currentLang.value])

/* ============================================================
   SEO — otimização profissional para capturar buscas por
   "oligoscan" e variações, em ES / PT / EN.
   ------------------------------------------------------------
   - Title rico em keywords primárias.
   - Meta description persuasiva, <160 chars.
   - Keywords em 3 idiomas.
   - Canonical + hreflang (x-default aponta para ES).
   - Open Graph + Twitter Card para compartilhamento.
   - JSON-LD:
       * Organization  — identidade da marca OligoCheck.
       * Product       — OligoCheck, com alternateName "OligoScan"
                         (essa chave é o que conecta buscas por
                         OligoScan ao novo produto nos SERPs).
       * FAQPage       — indexa as perguntas/respostas da seção.
       * BreadcrumbList — reforça hierarquia.
   ============================================================ */
const SITE_URL = 'https://portal.oligocheck.es'
const PAGE_PATH = '/oligoscan'
const OG_IMAGE = 'https://socheck.nyc3.cdn.digitaloceanspaces.com/6dce6cd1afe525bd7b8999-logo%20(1).svg'

const seoContent = {
  es: {
    title: 'OligoScan ahora es OligoCheck | Análisis Mineral Intracelular en Tiempo Real',
    description:
      'OligoScan evolucionó y ahora se llama OligoCheck: la misma tecnología líder mundial en análisis mineral intracelular no invasivo, ahora más precisa, más accesible y con resultados en 5 segundos.',
    keywords: [
      'oligoscan', 'oligocheck', 'oligoscan ahora es oligocheck',
      'análisis mineral intracelular', 'analisis mineral intracelular',
      'oligoelementos', 'metales pesados', 'estrés oxidativo',
      'espectrofotometría', 'análisis no invasivo',
      'test oligoscan', 'comprar oligoscan', 'precio oligoscan',
      'equipo oligoscan', 'oligoscan españa', 'oligoscan opiniones',
      'oligoscan funciona', 'oligocheck españa', 'oligocheck precio',
      'análisis minerales palma mano', 'análisis minerales tiempo real'
    ],
    faqTag: 'es'
  },
  pt: {
    title: 'OligoScan agora é OligoCheck | Análise Mineral Intracelular em Tempo Real',
    description:
      'O OligoScan evoluiu e agora se chama OligoCheck: a mesma tecnologia líder mundial em análise mineral intracelular não invasiva, agora mais precisa, mais acessível e com resultados em 5 segundos.',
    keywords: [
      'oligoscan', 'oligocheck', 'oligoscan agora é oligocheck',
      'análise mineral intracelular', 'analise mineral intracelular',
      'oligoelementos', 'metais pesados', 'estresse oxidativo',
      'espectrofotometria', 'análise não invasiva',
      'teste oligoscan', 'comprar oligoscan', 'preço oligoscan',
      'aparelho oligoscan', 'oligoscan brasil', 'oligoscan portugal',
      'oligoscan funciona', 'oligocheck brasil', 'oligocheck preço',
      'análise minerais palma da mão', 'análise minerais tempo real'
    ],
    faqTag: 'pt'
  },
  en: {
    title: 'OligoScan is now OligoCheck | Real-Time Intracellular Mineral Analysis',
    description:
      'OligoScan has evolved and is now called OligoCheck: the same world-leading technology for non-invasive intracellular mineral analysis, now more accurate, more accessible, with results in 5 seconds.',
    keywords: [
      'oligoscan', 'oligocheck', 'oligoscan is now oligocheck',
      'intracellular mineral analysis', 'trace elements analysis',
      'heavy metals test', 'oxidative stress analysis',
      'spectrophotometry analysis', 'non-invasive mineral test',
      'buy oligoscan', 'oligoscan price', 'oligoscan device',
      'oligocheck price', 'oligocheck device', 'real-time mineral analysis'
    ],
    faqTag: 'en'
  }
}

const canonicalPorLang = {
  es: `${SITE_URL}${PAGE_PATH}`,
  pt: `${SITE_URL}${PAGE_PATH}?lang=pt`,
  en: `${SITE_URL}${PAGE_PATH}?lang=en`
}

useSeo(() => {
  const lang = currentLang.value
  const seo = seoContent[lang] || seoContent.es
  const translation = translations[lang] || translations.es

  const canonical = canonicalPorLang[lang]

  /* JSON-LD Schema.org — o ponto-chave para SEO de "OligoScan" */
  const structuredData = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      '@id': `${SITE_URL}#organization`,
      name: 'OligoCheck',
      alternateName: ['OligoScan'],
      url: SITE_URL,
      logo: OG_IMAGE,
      sameAs: [
        'https://www.instagram.com/oligocheck_oficial/'
      ],
      contactPoint: [{
        '@type': 'ContactPoint',
        telephone: '+34617488404',
        contactType: 'customer support',
        availableLanguage: ['Spanish', 'Portuguese', 'English']
      }]
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Product',
      '@id': `${SITE_URL}${PAGE_PATH}#product`,
      name: 'OligoCheck',
      alternateName: ['OligoScan', 'OligoScan / OligoCheck'],
      description: seo.description,
      image: OG_IMAGE,
      brand: { '@type': 'Brand', name: 'OligoCheck' },
      manufacturer: { '@id': `${SITE_URL}#organization` },
      category: 'Medical Device / Mineral Analysis',
      url: canonical,
      additionalType: 'https://schema.org/MedicalDevice',
      keywords: seo.keywords.join(', ')
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: (translation.faqItems || []).map(item => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: { '@type': 'Answer', text: item.answer }
      }))
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'OligoCheck', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: 'OligoScan', item: canonical }
      ]
    }
  ]

  return {
    lang,
    title: seo.title,
    description: seo.description,
    keywords: seo.keywords,
    canonical,
    alternates: {
      'x-default': canonicalPorLang.es,
      es: canonicalPorLang.es,
      pt: canonicalPorLang.pt,
      en: canonicalPorLang.en
    },
    image: OG_IMAGE,
    imageAlt: 'OligoCheck — análise mineral intracelular não invasiva',
    type: 'product',
    structuredData
  }
})
</script>

<style scoped>
/* ============================================
   TÍTULO CUSTOMIZADO (usado dentro do slot #titulo do PageHero)
   ============================================ */
.titulo-virgula {
  color: rgba(255, 255, 255, 0.35);
  font-family: var(--ds-font-display);
  margin-left: -6px;
}

.titulo-antigo {
  font-family: var(--ds-font-body);
  font-size: 0.72em;
  color: var(--ds-text-muted);
  font-weight: normal;
  letter-spacing: 0;
  text-transform: lowercase;
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
}

.titulo-riscado {
  position: relative;
  color: var(--ds-text-dim);
  font-family: var(--ds-font-display);
  text-transform: none;
}

.titulo-riscado::after {
  content: '';
  position: absolute;
  left: -4px;
  right: -4px;
  top: 52%;
  height: 2px;
  background: var(--ds-warning);
  border-radius: 2px;
  transform: rotate(-3deg);
}

/* ============================================
   CAMINHOS (2 CTAs dentro do hero)
   ============================================ */
.caminhos-pergunta {
  font-family: var(--ds-font-bold);
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: var(--ds-text-dim);
  margin: 0 0 var(--ds-s-5);
}

.caminhos-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--ds-s-4);
  margin-bottom: var(--ds-s-7);
}

.caminho-card {
  display: flex;
  align-items: center;
  gap: var(--ds-s-4);
  text-align: left;
  background: var(--ds-surface-2);
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-r-lg);
  padding: 22px;
  text-decoration: none;
  color: var(--ds-text);
  transition: all var(--ds-t-smooth);
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.caminho-card::before {
  content: '';
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity var(--ds-t-base);
}

.caminho-compra::before {
  background: linear-gradient(135deg, rgba(245, 130, 32, 0.12), transparent 60%);
}

.caminho-suporte::before {
  background: linear-gradient(135deg, rgba(37, 211, 102, 0.12), transparent 60%);
}

.caminho-card:hover::before { opacity: 1; }

.caminho-card:hover {
  transform: translateY(-3px);
  box-shadow: var(--ds-shadow-lg);
}

.caminho-compra:hover { border-color: rgba(245, 130, 32, 0.45); }
.caminho-suporte:hover { border-color: rgba(37, 211, 102, 0.45); }

.caminho-icone {
  min-width: 56px;
  height: 56px;
  border-radius: var(--ds-r-md);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}

.caminho-compra .caminho-icone {
  background: var(--ds-gradient-warning);
  color: #fff;
  box-shadow: var(--ds-shadow-glow-warning);
}

.suporte-icone {
  background: var(--ds-gradient-success);
  color: #fff;
  box-shadow: var(--ds-shadow-glow-success);
}

.caminho-conteudo {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2px;
  position: relative;
  z-index: 1;
}

.caminho-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: var(--ds-text-dim);
  font-family: var(--ds-font-bold);
}

.caminho-titulo {
  font-family: var(--ds-font-bold);
  font-size: 18px;
  color: var(--ds-text);
  line-height: 1.2;
}

.caminho-desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.4;
  margin-top: 2px;
}

.caminho-seta {
  color: var(--ds-text-faint);
  transition: all var(--ds-t-base);
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}

.caminho-card:hover .caminho-seta {
  color: var(--ds-text);
  transform: translateX(4px);
}

/* ============================================
   SEÇÃO EXPLICATIVA (conteúdo custom dentro de SecaoPadrao)
   ============================================ */
.explicativa-grid {
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: 60px;
  align-items: center;
}

.explicativa-desc {
  font-size: 16px;
  color: var(--ds-text-muted);
  line-height: 1.6;
  margin: var(--ds-s-5) 0 var(--ds-s-7);
}

.antes-depois {
  display: flex;
  align-items: center;
  gap: var(--ds-s-4);
  margin-bottom: var(--ds-s-7);
  padding: var(--ds-s-5);
  background: var(--ds-surface-1);
  border: 1px solid var(--ds-border-subtle);
  border-radius: var(--ds-r-md);
}

.ad-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ad-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: rgba(255, 255, 255, 0.4);
  font-family: var(--ds-font-bold);
}

.ad-item strong {
  font-family: var(--ds-font-display);
  font-size: 22px;
  color: var(--ds-text);
}

.ad-antes strong {
  color: var(--ds-text-dim);
  text-decoration: line-through;
  text-decoration-color: var(--ds-warning);
  text-decoration-thickness: 2px;
}

.ad-seta {
  color: var(--ds-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.explicativa-lista {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.explicativa-lista li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.5;
}

.explicativa-lista li svg {
  color: var(--ds-ciano);
  background: rgba(26, 175, 149, 0.15);
  border-radius: 50%;
  padding: 3px;
  margin-top: 1px;
  flex-shrink: 0;
  box-sizing: content-box;
}

.explicativa-visual {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 380px;
}

.visual-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 110%;
  height: 90%;
  background: radial-gradient(circle, rgba(20, 203, 240, 0.2) 0%, transparent 70%);
  z-index: 0;
  animation: pulseGlow 5s ease-in-out infinite;
}

@keyframes pulseGlow {
  0%, 100% { opacity: 0.5; transform: translate(-50%, -50%) scale(0.95); }
  50% { opacity: 0.8; transform: translate(-50%, -50%) scale(1.05); }
}

.visual-img {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 440px;
  height: auto;
  filter: drop-shadow(0 20px 50px rgba(0, 0, 0, 0.4));
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
}

/* ============================================
   FEATURES (grid wrapper)
   ============================================ */
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: var(--ds-s-5);
}

/* ============================================
   TECH BOX (ESPECTROFOTOMETRIA)
   ============================================ */
.tech-box {
  margin-top: var(--ds-s-8);
  background:
    linear-gradient(135deg, rgba(20, 203, 240, 0.06) 0%, rgba(26, 175, 149, 0.04) 100%),
    rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(20, 203, 240, 0.2);
  border-radius: var(--ds-r-xl);
  padding: 36px;
  position: relative;
  overflow: hidden;
}

.tech-box::before {
  content: '';
  position: absolute;
  top: -60px;
  right: -60px;
  width: 220px;
  height: 220px;
  background: radial-gradient(circle, rgba(20, 203, 240, 0.15) 0%, transparent 70%);
  pointer-events: none;
}

.tech-box-grid {
  display: grid;
  grid-template-columns: 60px 1fr;
  gap: 24px;
  position: relative;
  z-index: 1;
}

.tech-box-icone {
  width: 56px;
  height: 56px;
  border-radius: var(--ds-r-md);
  background: linear-gradient(135deg, rgba(20, 203, 240, 0.2), rgba(20, 203, 240, 0.08));
  border: 1px solid rgba(20, 203, 240, 0.3);
  color: var(--ds-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: var(--ds-shadow-glow-azul);
}

.tech-box-label {
  font-family: var(--ds-font-bold);
  font-size: 11px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--ds-ciano);
  margin-bottom: 6px;
}

.tech-box-titulo {
  font-family: var(--ds-font-display);
  font-size: 22px;
  color: var(--ds-text);
  margin: 0 0 12px;
  line-height: 1.3;
  letter-spacing: -0.3px;
}

.tech-box-desc {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.6;
  margin: 0 0 22px;
}

.tech-box-lista {
  list-style: none;
  padding: 0;
  margin: 0 0 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  counter-reset: tech-steps;
}

.tech-box-lista li {
  display: flex;
  gap: 14px;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  align-items: flex-start;
  counter-increment: tech-steps;
  position: relative;
}

.tech-box-lista li::before {
  content: counter(tech-steps);
  width: 28px;
  height: 28px;
  border-radius: var(--ds-r-sm);
  background: var(--ds-accent-soft);
  color: var(--ds-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--ds-font-bold);
  font-size: 13px;
  border: 1px solid var(--ds-accent-border);
  flex-shrink: 0;
  margin-top: 1px;
}

.tech-step-body {
  flex: 1;
  min-width: 0;
}

.tech-box-lista li strong {
  display: block;
  font-family: var(--ds-font-bold);
  font-size: 14px;
  color: var(--ds-text);
  margin-bottom: 4px;
  line-height: 1.35;
}

.tech-box-lista li span {
  display: block;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.68);
  line-height: 1.55;
}

.tech-box-nota {
  display: inline-flex;
  align-items: center;
  gap: var(--ds-s-2);
  font-size: 12px;
  color: var(--ds-text-dim);
  margin: 0;
  padding-top: 14px;
  border-top: 1px solid var(--ds-border-subtle);
  font-style: italic;
}

.tech-box-nota svg {
  color: var(--ds-ciano);
  flex-shrink: 0;
}

@media (max-width: 720px) {
  .tech-box { padding: 26px 20px; border-radius: var(--ds-r-lg); }
  .tech-box-grid { grid-template-columns: 1fr; gap: var(--ds-s-4); }
  .tech-box-icone { width: 48px; height: 48px; }
  .tech-box-titulo { font-size: 19px; }
  .tech-box-desc { font-size: 14px; }
}

/* ============================================
   FORMULÁRIO — glow laranja de fundo
   ============================================ */
.secao-formulario::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  height: 300px;
  background: radial-gradient(circle, rgba(245, 130, 32, 0.08) 0%, transparent 70%);
  pointer-events: none;
}

.secao-formulario :deep(.ds-container) {
  position: relative;
  z-index: 1;
}

/* ============================================
   RESPONSIVO ESPECÍFICO DA PÁGINA
   ============================================ */
@media (max-width: 900px) {
  .caminhos-grid { grid-template-columns: 1fr; gap: var(--ds-s-3); }
  .caminho-card { padding: 18px; }

  .explicativa-grid { grid-template-columns: 1fr; gap: var(--ds-s-8); }
  .explicativa-visual { min-height: auto; order: -1; }
  .visual-img { max-width: 320px; }
}

@media (max-width: 480px) {
  .titulo-antigo { font-size: 0.68em; }
  .antes-depois { flex-direction: column; gap: var(--ds-s-3); text-align: center; }
  .ad-seta { transform: rotate(90deg); }
}
</style>
